<form [formGroup]="messageCodeForm">
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-md-6">
          <div class="md-form">
            <input
              mdbInput
              type="number" 
              class="form-control" 
              id="listID-control"
              formControlName="listId">
            <label for="listID-control">List ID</label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="md-form">
            <input
              mdbInput
              type="text" 
              class="form-control" 
              id="code-control"
              formControlName="criteriaCode"
              [ngClass]="{'is-invalid': messageCodeForm.get('criteriaCode').errors && 
                                        messageCodeForm.get('criteriaCode').touched}">
            <label for="code-control">Message Criteria Code</label>
            <div class="invalid-feedback">Please enter a Criteria Code.</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="md-form mt-0">
            <input
              mdbInput
              type="text" 
              class="form-control" 
              id="rule-description-control"
              formControlName="description">
            <label for="rule-description-control">Rule Description</label>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="md-form mt-0">
        SQL
        <textarea
          mdbInput
          id="sql-control"
          rows="5"
          class="form-control sql-area-height"
          readonly>{{messageCodeForm.get('sql').value}}
        </textarea>
      </div>

    </div>
  </div>
</form>
<app-query-builder 
  #queryBuilder
  *ngIf="initQueryBuilder"
  [_parentListID]="this.messageCodeForm.controls.listId.value" 
  [_parentQuery]="this.messageCodeRules"
  [_parentSource]="'createEditMessageCode'"
  (queryBuilderSave)="messageCodeSQLSave($event)"
  [(_parentPageTitle)]="this._pageTitle">            
</app-query-builder>
